import {ReactNode, useEffect, useRef} from 'react'

import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
interface Props {
  initialInView?: boolean
  active?: boolean
  partialVisibility?: null | 'top' | 'bottom'
  onChange: (isVisible: boolean) => void
  children: ReactNode
}

export const VisibilitySensor = ({
  initialInView = false,
  active = true,
  partialVisibility = null,
  children,
  onChange
}: Props) => {
  const onChangeRef = useRef(null)
  const {ref, inView} = useInView({
    initialInView,
    skip: !active
  })

  onChangeRef.current = onChange

  useEffect(() => {
    if (active) {
      onChangeRef.current(inView)
    }
  }, [active, inView])

  if (active) {
    if (partialVisibility === 'top') {
      return (
        <>
          <div ref={ref} />
          {children}
        </>
      )
    }

    if (partialVisibility === 'bottom') {
      return (
        <>
          {children}
          <div ref={ref} />
        </>
      )
    }

    return <div ref={ref}>{children}</div>
  }

  return <>{children}</>
}
